export default __webpack_public_path__ + "static/media/left-dedication.3582c4ef.png";